window.addEventListener('load', () => {
    const hash = window.location.hash;
    if (hash === '#adresse') {
        const targetElement = document.getElementById('adresse');
        if (targetElement) {
            // Utilisation de setTimeout pour retarder le défilement
            setTimeout(() => {
                const rect = targetElement.getBoundingClientRect();
                const offsetTop = rect.top + window.scrollY - 140;

                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }, 100); // Délai de 100 millisecondes
        }
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const cardNumbers = document.querySelectorAll('.card-number');
    const intros = document.querySelectorAll('.intro');

    // Vérifier si les classes .card-number et .intro sont présentes
    if (cardNumbers.length > 0 && intros.length > 0) {
        let maxHeight = 0;

        // Trouver la hauteur maximale parmi toutes les divs intro
        intros.forEach(intro => {
            const introHeight = intro.offsetHeight;
            if (introHeight > maxHeight) {
                maxHeight = introHeight;
            }
        });

        // Appliquer la hauteur maximale à toutes les divs intro
        intros.forEach(intro => {
            intro.style.height = `${maxHeight}px`;
        });
    }
});
